import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Dashboard, Reports, Login, PitDashboard, LogsDashboard, GuardDashboard, ChangePassword, CardSwapDashboard, ForgotPassword } from './pages';
import { connect, useSelector } from 'react-redux';
import { getRole, isAuthenticated } from 'redux/User/selectors';

const isValidPath = (path) => {
  const validPaths = [
    /^\/dashboard$/,
    /^\/pit-dashboard$/,
    /^\/logs\/[a-zA-Z0-9]+\/\d+$/, // matches /logs/:type (alphanumeric)/:id (numeric only)
    /^\/logs\/[a-zA-Z0-9]+\/\d+\/\d+$/, // matches /logs/:type/:id/:pitId
    /^\/reports$/,
    /^\/settings$/,
    /^\/card-swap$/,
  ];
  return validPaths.some((regex) => regex.test(path));
};

const PrivateRoutes = () => (
  <Switch>
    <Route exact path="/dashboard" component={Dashboard} />
    <Route exact path="/pit-dashboard" component={PitDashboard} />
    <Route exact path="/logs/:type/:id" component={LogsDashboard} />
    <Route exact path="/logs/:type/:id/:pitId" component={LogsDashboard} />
    <Route exact path="/reports" component={Reports} />
    <Route exact path="/settings" component={ChangePassword} />
    <Route exact path="/card-swap" component={CardSwapDashboard} />
    {!isValidPath(window.location.pathname) && <Redirect to="/dashboard" />}
  </Switch>
);

const GuardRoutes = () => (
  <Switch>
    <Route exact path="/dashboard" component={GuardDashboard} />
    {!isValidPath(window.location.pathname) && <Redirect to="/dashboard" />}
  </Switch>
);

const Routes = () => {
  // Redirect user to the correct component based on authentication status
  const { role, isUserAuthenticated } = useSelector((state) => ({
    role: getRole(state),
    isUserAuthenticated: isAuthenticated(state),
  }));
  if (isUserAuthenticated) {
    // User is authenticated
    return role === 'prw' ? <GuardRoutes /> : <PrivateRoutes />;
  }
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      {!isValidPath(window.location.pathname) && <Redirect to="/login" />}
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  // map your state to props here if needed
  role: getRole(state),
  isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(Routes);
